module.exports = __webpack_public_path__ + "img/art12.8c6b425c.png";